import React, { Fragment, useState, useEffect } from 'react';
import NewBpartner from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/NewBpartner/NewBpartner';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { wsGet, wsCreate, wsRemove } from 'services/WService';
import CustomerIncompleteMap from './CustomerIncompleteMap';
import Button from 'components/CustomButtons/Button';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Toasty, useToasty } from 'hooks/Toasty';
import { makeStyles } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import GridContainer from 'components/Grid/GridContainer';
import { LayerProvider } from 'contexts/layerContext';
import useLayerContext from 'contexts/layerContext';
import GridItem from 'components/Grid/GridItem';
import { InputLabel } from '@material-ui/core';
import { useModal } from 'hooks/useModal';
import CustomerPhotoModal from './CustomerPhotoModal';

const useStyles = makeStyles(() => ({
  ...styles,
}));

function CustomerIncompleteDetail() {
  const { id } = useParams();
  const classes = useStyles();
  const [customer, setCustomer] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [businessPartner, setBusinessPartner] = useState({});
  const [zoneId, setZoneId] = useState();
  const [marker, setMarker] = useState(null);
  const { selectedLayer } = useLayerContext();
  const [photoModel, setPhotoOpen] = useModal();
  const [processing, setProcessing] = useState(false);

  const [alert, setAlert] = useState(null);
  const [notify, showNotify] = useToasty();

  function showAlert(id) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Desea ver el socio creado?"
        onConfirm={() => {
          window.location = `/admin/socio-negocio/datos-maestros/clientes/${id}`;
        }}
        onCancel={() => {
          window.location = '/admin/socio-negocio/datos-maestros/incompletos';
        }}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      ></SweetAlert>,
    );
  }

  async function getBusinessPartner() {
    let [bpRes, res] = await Promise.all([
      wsGet('base/business-partner', '0'),
      wsGet('ordm/customer', id),
    ]);
    let customer = res.data.customer;
    if (res.data.zone_id !== null) {
      setZoneId(res.data.zone_id);
    }
    setCustomer(customer);
    setBusinessPartner({
      ...bpRes.data,
      CardName: customer.business_name,
      first_name: customer.first_name,
      second_name: customer.second_name,
      father_name: customer.father_name,
      mothert_name: customer.mothert_name,
      LicTradNum: customer.document_number,
      base_document_type_id: Number(customer.base_document_type_id),
      base_payment_term_id: Number(customer.base_payment_term_id),
      base_person_type_id: Number(customer.base_person_type_id),
      Cellular: customer.phone_number,
      E_Mail: customer.email,
      Address: customer.base_address_description,
      //
      CardType: customer.CardType || 'C',
      // base_person_type_id: 2,
      // base_document_type_id: 2 || 4,
    });
    setAddresses(res.data.addresses);
  }

  async function approve(bPartnerData) {
    if(selectedLayer === undefined) return window.alert('Seleccione una capa');
    setProcessing(true);
    let data = {
      CardType: 'C',
      ordm_customer_id: customer.id,
      base_layer_id: selectedLayer.id,
      ...businessPartner,
      ...bPartnerData,
    };

    if (marker !== null) {
      data.latitude = marker.lat;
      data.longitude = marker.lng;
    }

    let res = await wsCreate('base/business-partner/incomplete', data);
    if (res.success) {
      showNotify(res.message);
      showAlert(res.data.id);
    } else {
      showNotify(res.message, 'error');
    }
    setProcessing(false);
  }

  async function annular() {
    setProcessing(true);
    let res = await wsRemove('base/business-partner/incomplete', customer.id);
    if (res.success) {
      showNotify(res.message);
      window.location = '/admin/socio-negocio/datos-maestros/incompletos';
    } else {
      showNotify(res.message, 'error');
    }
    setProcessing(false);
  }

  useEffect(() => {
    getBusinessPartner();
  }, []);

  return (
    <Fragment>
      {alert}
      <Toasty action={notify} />
      <NewBpartner
        title={'Punto Gps'}
        queryType={'C'}
        saveButton={false}
        incomplete={true}
        reload={getBusinessPartner}
        onSubmit={approve}
        businessPartner={businessPartner}
        setBusinessPartner={setBusinessPartner}
        zoneId={zoneId}
      />
      <CustomerPhotoModal
        model={photoModel}
        setOpen={setPhotoOpen}
        showNotify={showNotify}
        setCustomer={setCustomer}
      />
      {customer.photos !== undefined && (
        <>
          <GridItem xs={12}>
            <InputLabel>
              Fotos <small style={{ fontSize: '10px' }}>(Max 5)</small>
            </InputLabel>
          </GridItem>
          <GridItem xs={12} style={{ position: 'relative' }}>
            <div
              style={{
                width: '100%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                }}
              >
                {customer.photos.map((photo) => {
                  return (
                    <div
                      key={photo.id}
                      style={{
                        width: '100px',
                        height: '100px',
                        borderRadius: '5px',
                        border: '1px solid black',
                        marginRight: '5px',
                        cursor: 'pointer',
                        backgroundImage: `url(${photo.file_url})`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                      }}
                      onClick={() => {
                        setPhotoOpen({ ...customer, ...photo });
                      }}
                    ></div>
                  );
                })}
              </div>
            </div>
          </GridItem>
        </>
      )}
      <CardContainer>
        <CustomerIncompleteMap
          zoneId={zoneId}
          customer={customer}
          addresses={addresses}
          businessPartner={businessPartner}
          setBusinessPartner={setBusinessPartner}
          marker={marker}
          setMarker={setMarker}
        />
      </CardContainer>

      <GridContainer>
        <GridItem xs={12}>
          <Button color="danger" onClick={annular} style={{ float: 'right' }} disabled={processing}>
            Anular
          </Button>
          <Button
            color="success"
            form="new-bpartner-form"
            type="submit"
            style={{ float: 'right' }}
            disabled={processing}
          >
            Aprobar
          </Button>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}

export default () => {
  return (
    <LayerProvider>
      <CustomerIncompleteDetail />
    </LayerProvider>
  );
};
